import React, { useContext, useState } from "react";
import InputsContext from "../contexts/InputsContext";
import { findInputs } from "../concerns/findInputs";
import TextField from "./../../../inputs/TextField";
import CheckBox from "./../../../inputs/CheckBox";

const TextStep = ({ stepIndex }) => {
  const { inputs, setInputs } = useContext(InputsContext);
  const thisStepInputs = findInputs(inputs, stepIndex);

  const stepIsValid = () => {
    let res = true;
    thisStepInputs["inputs"].forEach((el) => {
      if (!el.valid) {
        res = false;
      }
    });
    thisStepInputs.valid = res;
    setInputs({ ...inputs });
  };

  const inputIsValid = (value, fieldIndex) => {
    thisStepInputs["inputs"].forEach((el) => {
      if (el.index === fieldIndex) {
        el.valid = value;
      }
      setInputs({ ...inputs });
    });
    stepIsValid();
  };

  const ThisStepsInputs = thisStepInputs["inputs"].map((el, index) => {
    return (
      <TextField
        key={index}
        model={inputs.model}
        label={el.label}
        field={el.field}
        required={true}
        kind={el.kind}
        type={el.type}
        valid={el.valid}
        inputIsValid={inputIsValid}
        index={el.index}
        errorMessage={el.errorMessage}
      />
    );
  });

  return (
    <div className={inputs.currentIndex === stepIndex ? "block " : "hidden"}>
      <div className="text-4xl font-bold mb-10">{thisStepInputs.label}</div>
      {inputs.currentIndex === inputs.steps.length - 1 && (
        <div className="my-10 text-cyan-500 text-xl font-bold">
          ⭐ Dernière étape et votre devis est prêt ! ⭐
        </div>
      )}
      <div className="justify-centergrid grid-cols-2 gap-4">
        {ThisStepsInputs}
        {inputs.currentIndex === inputs.steps.length - 1 && (
          <CheckBox
            nestedModel="quote"
            model="contact"
            field="email_opt_in"
            label="J’accepte de recevoir des offres promotionnelles de la part d’ Assurances Vélo et de ses partenaires”."
          />
        )}
        {inputs.currentIndex === inputs.steps.length - 1 && (
          // <CheckBox
          //   nestedModel="quote"
          //   model="contact"
          //   field="phone_opt_in"
          //   label="Je ne souhaite pas être contacté(e) par téléphone par Assurances Vélo."
          // />
          <div className="text-orange-500 font-bold text-base">
            En renseignant mes coordonnées je consens à être contacté par un
            conseiller Assurances Vélo.
          </div>
        )}
      </div>
    </div>
  );
};

export default TextStep;
